import React, { PureComponent, ReactNode } from 'react'
import StyledDiv from './styles'

interface IProps {
  // What is being suggested: a stop (pin with a plus) or a timetable (clock with a plus).
  kind: 'stop' | 'schedule'
  label: string
  onPress: () => void
  className?: string
}

interface IState {
  showLabel: boolean
}

/**
 * The round "suggest" button from the app's booking flow: a tap reveals the label next to it,
 * a tap on the label goes to the suggestions form. Coloured through `currentColor`.
 */
export class SuggestionButton extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = { showLabel: false }
  }

  private get icon(): ReactNode {
    if (this.props.kind === 'stop') {
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path fill="currentColor" d="M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z" />
        </svg>
      )
    }
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M10 8v6l4.7 2.9.8-1.2-3.9-2.3V8H10zm10 4h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm-8 10c-1.2 0-2.3-.2-3.4-.6A10 10 0 0 1 2 12a10 10 0 0 1 20-.3 4 4 0 0 0-2-.4V12a8 8 0 1 0-8 8h.3c.3.8.7 1.4 1.3 2H12z" />
      </svg>
    )
  }

  public render(): ReactNode {
    const { label, onPress, className } = this.props
    const { showLabel } = this.state

    return (
      <StyledDiv className={ className }>
        { showLabel &&
          <button type="button" className="label" onClick={ onPress }>{ label }</button>
        }
        <button
          type="button"
          className={ `round ${ showLabel ? 'open' : '' }` }
          onClick={ this.toggleLabel }
          aria-label={ label }
        >
          { this.icon }
        </button>
      </StyledDiv>
    )
  }

  private toggleLabel = (): void => {
    this.setState({ showLabel: !this.state.showLabel })
  }
}
